export * from "./local-storage-keys";

export enum FlightType {
    RT = "RT",
    OW = "OW",
}

export enum PassengerType {
    ADT = "ADT",
    CHD = "CHD",
    INF = "INF",
    PET = "PET",
}